import { render, staticRenderFns } from "./lrOldTable.vue?vue&type=template&id=05a48e09&"
import script from "./lrOldTable.vue?vue&type=script&lang=js&"
export * from "./lrOldTable.vue?vue&type=script&lang=js&"
import style0 from "./lrOldTable.vue?vue&type=style&index=0&id=05a48e09&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports